module.exports = __webpack_public_path__ + "static/media/font_bold.988a4c5a.woff2";